import React, { Component } from "react";
import Devview from "../images/devview.png";
import Hostels from "../images/hostel.png";
import googleAssistant from "../images/google-assistant.png";
import portfolio from "../images/portfolio.png";
import Audotask from "../images/audotask.png";
import ExcelShortcuts from "../images/excel-shortcuts.png";
import Yipo from "../images/yipo.png";
import Googleplay from "../images/google-play.png";
import AppStore from "../images/app-store.png";

export class ProjectsComponent extends Component {
  render() {
    return (
      <div className="projects" id="project">
        <div className="d-flex justify-content-center">
          <h1 id="projects-stat" className="mt-5">
            Projects
          </h1>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-sm-12">
              <a
                href="https://audotask.app"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="card scale-image projects-card">
                  <img src={Audotask} className="card-img-top " alt="devview" />
                  <div className="card-body">
                    <p
                      className="card-text text-dark"
                      style={{ fontSize: "13px" }}
                    >
                      Manage Work for your teams very easily by using a built-in
                      🎙️ sound recorder and custom reminder email to your team
                      members in your Audotask workspace.
                    </p>
                  </div>
                </div>
              </a>
            </div>

            <div className="col-lg-6 col-sm-12">
              <a
                href="https://play.google.com/store/apps/details?id=com.yipoapp"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="card scale-image projects-card">
                  <img src={Yipo} className="card-img-top " alt="hostels" />
                  <div className="card-body">
                    <p
                      className="card-text text-dark"
                      style={{ fontSize: "13px" }}
                    >
                      YIPO is an A to Z baby names app, having 20,000+ popular
                      baby names with meanings across different categories like
                      Biblical Names, Arabic Names, etc. in a super amazing User
                      experience and is available on both Play Store & App
                      Store.
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-lg-6 col-sm-12">
              <a href="/" target="_blank" rel="noopener noreferrer">
                <div className="card scale-image projects-card">
                  <img
                    src={portfolio}
                    className="card-img-top "
                    alt="portfolio"
                  />
                  <div className="card-body">
                    <p
                      className="card-text text-dark"
                      style={{ fontSize: "13px" }}
                    >
                      It's my portfolio website where I have showcases my skills
                      and work experience. It contains an awesome contact form
                      which you can fill to get in touch with me.
                    </p>
                  </div>
                </div>
              </a>
            </div>
            <div className="col-lg-6 col-sm-12">
              <a
                href="https://play.google.com/store/apps/details?id=com.excelshortcuts"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="card scale-image projects-card">
                  <img
                    src={ExcelShortcuts}
                    className="card-img-top "
                    alt="assistant"
                  />
                  <div className="card-body">
                    <p
                      className="card-text text-dark"
                      style={{ fontSize: "13px" }}
                    >
                      Excel Shortcut Keys - Excel Shortcuts provides a list of
                      500+ shortcut keys for Windows and macOS and is available
                      on both Play Store.
                    </p>
                  </div>
                </div>
              </a>{" "}
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-5">
          <a
            href="https://github.com/hardy1334"
            target="_blank"
            rel="noopener noreferrer"
          >
            <input type="button" className="jelly" value="More" />
          </a>
        </div>
      </div>
    );
  }
}

export default ProjectsComponent;
